/**
 * init Tree Item
 * @param accGroup
 */
window.initTreeItem = function (accGroup) {
    if (accGroup.find('.accordion__item').length && !accGroup.hasClass('initialized')) {
        accGroup.find('.accordion__item').each(function () {
            const accItem = $(this);
            const accTrigger = accItem.children('.accordion__item__title');
            const accBody = accItem.children('.accordion__item__body');

            // set display none for none active elements
            if (!accItem.hasClass('accordion__item--active')) {
                accBody.hide();
            }

            // click event
            if (accTrigger.length && accBody.length) {
                // reset bound click event just in case
                accTrigger.off('click');
                // bind new click event
                accTrigger.on('click', function () {
                    triggerAccordion(accTrigger);
                });
            }

            // set initialized class
            accGroup.addClass('initialized');
        });
    }
};

/**
 * open Tree Item
 * @param item
 */
window.openTreeItem = function (item) {
    item.addClass('tree-item--active').children('.tree-item__body').show();
};

/**
 * close Tree Item
 * @param item
 */
window.closeTreeItem = function (item) {
    item.removeClass('tree-item--active').children('.tree-item__body').hide();
};

/**
 * toggle Tree Item
 * @param item
 */
window.toggleTreeItem = function (item) {
    if (item.hasClass('tree-item--active')) {
        closeTreeItem(item);
    } else {
        openTreeItem(item);
    }
};

/**
 * trigger Tree Group
 * @param openClassString
 * @param closeClassString
 */
window.triggerTreeGroup = function (openClassString = '', closeClassString = '') {
    if (closeClassString !== '') {
        $(closeClassString).each(function () {
            const ele = $(this);
            closeTreeItem(ele);
        });
    }
    if (openClassString !== '') {
        $(openClassString).each(function () {
            const ele = $(this);
            openTreeItem(ele);
        });
    }
};